<template>
    <div class="Home-container">
        <pageHeader />
        <div class="s-b">
            <div class="left-form-warp">
                <div class="s-b" style="margin-bottom: 30px;">
                    <monitor />
                    <count />
                </div>
                <div class="s-b">
                    <heatingSystemWarning />
                    <electricalWarning />
                    <maintenanceTips />
                </div>
            </div>

            <div class="right-form-warp">
                <heatingStatistics />
                <waterConsumptionStatistics />
                <userStatistics />
            </div>
        </div>
    </div>
</template>

<script>
  import pageHeader from './components/header.vue'
  import monitor from './components/monitor/index.vue'
  import count from './components/count/index.vue'
  import heatingSystemWarning from './components/heating-system-warning/index.vue'
  import electricalWarning from './components/electrical-warning/index.vue'
  import maintenanceTips from './components/maintenance-tips/index.vue'
  import heatingStatistics from './components/heating-statistics/index.vue'
  import waterConsumptionStatistics from './components/water-consumption-statistics/index.vue'
  import userStatistics from './components/user-statistics/index.vue'
  export default {
    components: {
      pageHeader,
      monitor,
      count,
      heatingSystemWarning,
      electricalWarning,
      maintenanceTips,
      heatingStatistics,
      waterConsumptionStatistics,
      userStatistics
    },
    inject: ['app'],
    data () {
      return {
        timer: null
      }
    },
    watch: {
      '$route' (n) {
        if (n && n.name !== 'Common.Home') {
          // 离开页面
          clearInterval(this.timer)
        }
      }
    },
    mounted () {
      this.$Bus.emit('index', {
        showToast: true
      })
      // 一小时刷新一次
      this.timer = setInterval(() => {
        this.$Bus.emit('index', {
          showToast: true
        })
      }, 1000 * 60 * 60)
    }
  }
</script>

<style lang="less" scoped>
    .Home-container {
        position: relative;
        box-sizing: border-box;
        margin: 0 auto;
        padding: 0 32px 32px;
        width: 1920px;

        .s-b {
            display: flex;
            justify-content: space-between;
        }

        .left-form-warp {
            width: 1227px;
        }

        .right-form-warp {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
        }
    }
</style>
